import {DTemplate} from './DTemplate.js';

/**
 * RoomMonitor is a custom element that will show some text explaining the
 * state of a Room / Stream, and whether a user has a ticket or not.
 * It is purely a DISPLAY system.
 */
export class RoomMonitor extends HTMLElement {
	constructor() {
		super();

		[this.el, this.$] = DTemplate(`RoomMonitor`);
		this.attachShadow({mode:`open`});
		this.shadowRoot.appendChild(this.el);

		this.has_ticket = false;
		this.stream_started = false;
		document.addEventListener(`veedo-ticket`, evt=>this.ticket(evt));
		document.addEventListener(`veedo-stream-state`, evt=>this.streamState(evt));
		console.log(`veedo-room-monitor created `, this);
	}
	connectedCallback() {
	}
	ticket(evt) {
		console.log(`RoomMonitor: veedo-ticket event hasTicket=`, evt.detail);
		this.$.ticket.innerText = evt.detail ? "You have a ticket" : "No Ticket";
	}
	streamState(evt) {
		console.log(`RoomMonitor: veedo-stream-state event `, evt.detail);
		switch (evt.detail) {
		case `STREAM_FILE_ABSENT`:
			this.$.stream.innerText = `Stopped`;
			this.stream_started=false;
			break;
		case `STREAM_FILE_PRESENT`:
			this.$.stream.innerText = `Started`;
			this.stream_started=true;
			break;
		default:
			this.$.stream.innerText = evt.detail;
			this.stream_started=false;
			break;
		}
	}
}
customElements.define(`veedo-room-monitor`, RoomMonitor);